import { Injectable } from '@angular/core';
import { CurrentUserService } from '@rma/authentication/public/user';
import { SubscriptionProductService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { DynamicAssetLoaderService, DynamicLoaderAssets } from '@rma/generic/util/dynamic-asset-loader';
import { FeatureFlags, FeaturesService } from '@rma/generic/util/feature-flags';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { ChatApiService } from './chat-api.service';

declare global {
  interface Window {
    // PLEASE MAKE YOUR TYPES, DON'T JUST DISABLE IT
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercomSettings?: any;
  }
  // PLEASE MAKE YOUR TYPES, DON'T JUST DISABLE IT
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function Intercom(value: string, ...args: any[]): void;
}

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  constructor(
    private readonly chatApiService: ChatApiService,
    private readonly userService: CurrentUserService,
    private readonly dynamicAssetLoader: DynamicAssetLoaderService,
    private readonly featureService: FeaturesService,
    private readonly subscriptionProductService: SubscriptionProductService,
  ) {}

  public initialise(): void {
    const trialDays$ = this.subscriptionProductService.availableTrialDays$.pipe(
      take(1),
      catchError((_) => of(0)),
    );

    this.featureService
      .getFeature$(FeatureFlags.EnableIntercom, false)
      .pipe(
        filter((x) => x),
        switchMap(() => this.userService.currentUser$),
        filter((x) => x !== null && !x.isImpersonating),
        switchMap(() => this.chatApiService.userChatData$.pipe(take(1))),
        filter((x) => !!x['app_id']),
        take(1),
        switchMap((userChatData) => trialDays$.pipe(map((trialDays) => ({ userChatData, trialDays })))),
      )
      .subscribe(({ userChatData, trialDays }) => {
        window.intercomSettings = {
          ...userChatData,
          available_trial_days: trialDays,
          custom_launcher_selector: '#accessible_intercom_launcher',
        };
        this.dynamicAssetLoader.appendAsset(DynamicLoaderAssets.IntercomScript);
      });
  }
}
